import Spinner from './Spinner';

export default Spinner;
export * from './Spinner';
